"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMPORTS_FROM_STUDIO = exports.IMPORTS_FROM_APID = exports.ASSET_DOWNLOAD = exports.ASSET_DEPENDENT = exports.ASSET_CONTRACT = void 0;
var ASSET_DOWNLOAD = exports.ASSET_DOWNLOAD = {
  key: 'assetDownload',
  label: 'Downloads',
  description: 'Number of files downloaded from the Exchange APIs',
  color: '#5779A3',
  type: 'period'
};
var IMPORTS_FROM_APID = exports.IMPORTS_FROM_APID = {
  key: 'importsFromApid',
  label: 'API Designer imports',
  description: 'Number of times the asset was imported from API Designer',
  type: 'period',
  color: '#84b5b2'
};
var IMPORTS_FROM_STUDIO = exports.IMPORTS_FROM_STUDIO = {
  key: 'importsFromStudio',
  label: 'Studio imports',
  description: 'Number of times the asset was imported from Studio',
  type: 'period',
  color: '#84b5b2'
};
var ASSET_DEPENDENT = exports.ASSET_DEPENDENT = {
  key: 'assetDependent',
  label: 'Dependents',
  description: 'Number of assets dependents',
  type: 'all-time',
  color: '#e49244'
};
var ASSET_CONTRACT = exports.ASSET_CONTRACT = {
  key: 'assetContract',
  label: 'Contracts',
  description: 'Number of approved API instance contracts',
  type: 'all-time',
  color: '#a77d9f'
};
//# sourceMappingURL=metrics.js.map